import { ComparisonPageTemplate } from "@/components/ComparisonPageTemplate";
import { Brain, Users, Clock } from "lucide-react";

const CSWvsiDoRecall = () => {
  return (
    <ComparisonPageTemplate
      platformName="iDoRecall"
      platformUrl="https://idorecall.com"
      seoDescription="Compare CSW and iDoRecall flashcard platforms. Discover why CSW offers a simpler interface and better real-time collaboration."
      seoKeywords="CSW vs iDoRecall, iDoRecall alternative, free flashcard app, source-linked flashcards"
      canonicalUrl="https://csw.live/flash-cards/csw-vs-idorecall/"
      heroDescription="Looking for a simpler alternative to iDoRecall? CSW offers intuitive flashcard study with collaborative features."
      alternativeDescription="While iDoRecall links flashcards to source materials, CSW provides a more accessible, collaborative study experience."
      background="iDoRecall links flashcards directly to uploaded study materials with classes, study groups, and leaderboards."
      pros={[
        { text: "Flashcards linked to source materials" },
        { text: "Classes and study groups" },
        { text: "Leaderboards for competition" }
      ]}
      cons={[
        { text: "Free plan has limited storage" },
        { text: "Complex interface" },
        { text: "Not designed for live quizzes" }
      ]}
      cswFeatures={[
        { text: "Simple Interface", available: true },
        { text: "Collaborative Study", available: true },
        { text: "Live Quiz Features", available: true },
        { text: "Free Access", available: true }
      ]}
      competitorFeatures={[
        { text: "Simple Interface", available: false },
        { text: "Collaborative Study", available: true },
        { text: "Live Quiz Features", available: false },
        { text: "Free Access", available: false }
      ]}
      benefits={[
        { icon: Brain, title: "Intuitive Design", description: "Start studying immediately without complexity." },
        { icon: Users, title: "Real-time Collaboration", description: "Study with friends in live sessions." },
        { icon: Clock, title: "Live Quizzes", description: "Engage with real-time quiz competitions." }
      ]}
      forStudentsText="CSW simplifies what iDoRecall complicates. Get collaborative flashcard study with live quizzes."
      pricingText="iDoRecall's full features require premium with storage limits. CSW offers unlimited access free."
      competitorPrice="$12/month"
    />
  );
};

export default CSWvsiDoRecall;
